module.exports = __webpack_public_path__ + "img/JPG.bfdae281.svg";